export default __webpack_public_path__ + "static/media/bar-fleet.415bd755.svg";